// import { Card, CardContent, Label } from 'semantic-ui-react'
// import { AppPrimaryButton, AppSecondaryButton } from 'elements'
// import {
//     AppEditButton,
//     AppRemoveButtonPopup,
//     AppTable,
//     FlexBox,
//     FlexRowBetween,
//     FlexRowWrap,
// } from 'components'
// import React, { useMemo } from 'react'
// import { Link } from 'react-router-dom'
// import { CommonUtility, DateFormat, DateUtility, StatusType } from 'utility'
// import { Clock } from 'phosphor-react'
// import { useTabletAndBelowMediaQuery } from 'layout'

// const TaskCard = ({ item, onRemove, onEdit, onViewReport }) => (
//     <Card fluid>
//         <CardContent>
//             <FlexRowBetween>
//                 <h4 title={item.CustomerName}>
//                     {CommonUtility.truncateString(item.CustomerName, 20)}
//                 </h4>
//                 <span>
//                     <Label>{item.StatusName}</Label>
//                 </span>
//             </FlexRowBetween>
//             <h5 className="mt-0 align-items-center d-flex">
//                 <Clock className="me-1" />
//                 {DateUtility.dateToLocalISO(
//                     new Date(item.InspectionDate),
//                     DateFormat.mmDD,
//                 )}{' '}
//                 -
//                 {DateUtility.dateToLocalISO(
//                     new Date(item.TaskDue),
//                     DateFormat.mmDD,
//                 )}
//             </h5>
//             <FlexRowWrap className="justify-content-end ">
//                 {StatusType.Completed === item.Status ? (
//                     <AppSecondaryButton onClick={() => onViewReport(item)}>
//                         View Report
//                     </AppSecondaryButton>
//                 ) : (
//                     <Link to={`/app/templates/inspection/${item.TemplateId}`}>
//                         <AppSecondaryButton title="Resume Inspection">
//                             Resume
//                         </AppSecondaryButton>
//                     </Link>
//                 )}
//                 {/* <AppEditButton onClick={onEdit} /> */}
//                 <AppEditButton onClick={() => onEdit(item)} />

//                 <AppRemoveButtonPopup onConfirm={() => onRemove(item.TaskId)} />
//             </FlexRowWrap>
//         </CardContent>
//     </Card>
// )

// export const InspectionTaskList = ({
//     data,
//     filter,
//     pageChanged,
//     totalCount,
//     onRemove,
//     onEdit,
//     onResume,
//     onViewReport,
// }) => {
//     const isMobile = useTabletAndBelowMediaQuery()
//     const columns = useMemo(
//         () => [
//             {
//                 title: 'Title',
//                 key: 'Title',
//             },
//             {
//                 title: 'Customer Name',
//                 key: 'CustomerName',
//             },
//             {
//                 title: 'Status',
//                 key: 'StatusName',
//             },
//             {
//                 title: 'Due Date',
//                 render: item => (
//                     <span>
//                         {DateUtility.dateToLocalISO(
//                             new Date(item.TaskDue),
//                             DateFormat.date,
//                         )}
//                     </span>
//                 ),
//             },
//             {
//                 title: 'Actions',
//                 key: 'Actions',
//                 render: item => (
//                     <FlexBox className="justify-content-center">
//                         {StatusType.Completed === item.Status ? (
//                             <AppPrimaryButton
//                                 onClick={() => onViewReport(item)}
//                                 type="button"
//                             >
//                                 View Report
//                             </AppPrimaryButton>
//                         ) : (
//                             <Link
//                                 to={`/app/templates/inspection/${item.TemplateId}`}
//                             >
//                                 <AppSecondaryButton
//                                     title="Resume Inspection"
//                                     type="button"
//                                 >
//                                     Resume {!isMobile && 'Inspection'}
//                                 </AppSecondaryButton>
//                             </Link>
//                         )}
//                         <AppPrimaryButton
//                             onClick={() => {
//                                 onEdit(item)
//                                 console.log(item)
//                             }}
//                             type="button"
//                         >
//                             Edit
//                         </AppPrimaryButton>
//                         <AppRemoveButtonPopup
//                             onConfirm={() => onRemove(item.TaskId)}
//                         />
//                     </FlexBox>
//                 ),
//             },
//         ],
//         [data, totalCount, filter, isMobile],
//     )
//     return (
//         <>
//             <AppTable
//                 data={data}
//                 columns={columns}
//                 pageChanged={pageChanged}
//                 filter={filter}
//                 totalCount={totalCount}
//                 mobileCard={
//                     <TaskCard
//                         onEdit={onEdit}
//                         onRemove={onRemove}
//                         onResume={onResume}
//                         onViewReport={onViewReport}
//                     />
//                 }
//             />
//         </>
//     )
// }

import { Card, CardContent, Label, Button, Modal, Checkbox } from 'semantic-ui-react'
import { AppPrimaryButton, AppButton } from 'elements'
import {
    AppEditButton,
    AppRemoveButtonPopup,
    AppTable,
    FlexBox,
    FlexRowBetween,
    FlexRowWrap,
    RejectModal,
} from 'components'
import React, { useMemo, useState, useRef, useEffect, useCallback } from 'react'
import { createPortal } from 'react-dom'
import { Link, useNavigate } from 'react-router-dom'
import {
    CommonUtility,
    DateFormat,
    DateUtility,
    StatusType,
    AuthService,
    ReportApprovalService,
    InspectionService,
    TemplateService,
    isTaskReadOnly,
} from 'utility'
import {
    getTaskAuditIdForApproval,
    getTaskCompletedReportId,
    getTaskInspectionRouteId,
    getTaskIsApprovedFlag,
    getTaskTemplateSettingId,
    isPostCompleteEditBlocked,
    mapDashboardTaskForActions,
} from './dashboard/task-dashboard-utils'
import { useAuth } from 'context'
import { isApprovalAdmin } from 'utility/role-model'
import { useNotification } from 'hooks/toast'
import {
    Clock,
    Repeat,
    PencilSimple,
    Trash,
    XCircle,
    CheckCircle,
    DotsThreeVertical,
    Printer,
    X,
    ClockCounterClockwise,
} from 'phosphor-react'
import { EmailHistoryPanel } from 'page-components/report/EmailHistoryPanel'
import { useTabletAndBelowMediaQuery } from 'layout'
import styled from 'styled-components'

const MENU_ESTIMATED_HEIGHT = 360

const ActionDropdownContainer = styled.div`
    position: relative;
    display: inline-block;
`

const DropdownMenuPortal = styled.div`
    position: fixed;
    background: white;
    border: 1px solid #e8e9e9;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    z-index: 2000;
    padding: 4px 0;
`

const MenuItem = styled.div`
    padding: 12px 16px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    gap: 12px;
    transition: background-color 0.2s ease;
    font-size: 14px;
    color: ${props => {
        if (props.disabled) return '#999';
        if (props.success) return '#16a34a';
        return props.danger ? '#dc3545' : '#333';
    }};
    font-weight: ${props => (props.success ? 600 : 400)};
    opacity: ${props => props.disabled ? 0.5 : 1};
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};

    &:hover {
        background-color: ${props => props.disabled ? 'transparent' : '#f8f9fa'};
    }
`

const CardActionsRow = styled.div`
    display: flex;
    gap: 6px;
    width: 100%;
`

const CardPrimaryButton = styled(AppPrimaryButton)`
    &&& {
        flex: 1;
        width: 100%;
        margin: 0 !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        padding: 0.6em 1em !important;
        min-height: unset !important;
    }
`

const CardActionMenu = styled.button`
    padding: 6px 10px;
    font-size: 12px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    background: #fff;
    cursor: pointer;
    min-width: 36px;
`

// Temporary: hide Edit in the actions popup. Set to true to restore.
const SHOW_TASK_EDIT_MENU_OPTION = false
const WK_COMPANY_ID = 34930

const getUserCompanyId = user =>
    Number(user?.CompanyId ?? user?.Companies?.[0]?.CompanyId)

const CardActionPlanButton = styled(AppButton)`
    &&& {
        flex: 1;
        width: 100%;
        margin: 0 !important;
        font-size: 11px !important;
        font-weight: 500 !important;
        padding: 0.6em 0.5em !important;
        min-height: unset !important;
        white-space: nowrap;
    }
`

export const TaskActionBoxes = ({
    item,
    onViewReport,
    onEdit,
    onRemove,
    onReject,
    onReopen,
    onClosePreview,
    variant = 'table',
    reportApproved = false,
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [rejectOpen, setRejectOpen] = useState(false)
    const [rejecting, setRejecting] = useState(false)
    const [menuStyle, setMenuStyle] = useState(null)
    const dropdownRef = useRef(null)
    const menuRef = useRef(null)
    const navigate = useNavigate()
    const { user } = useAuth()
    const { errorToast } = useNotification()
    // direct approval from the task list = company admins (the server's rule). Approvers named in an approval
    // workflow (login CanApproveReports) act from Report Approvals > Awaiting me.
    const showApprove = isApprovalAdmin(user)
    const [approving, setApproving] = useState(false)
    const [printingReport, setPrintingReport] = useState(false)
    const [emailHistoryOpen, setEmailHistoryOpen] = useState(false)
    const [approvalInfo, setApprovalInfo] = useState(null)
    const [approvalStatusLoading, setApprovalStatusLoading] = useState(false)
    // Collection default: no config row => post-complete edit allowed
    const [allowPostCompleteEdit, setAllowPostCompleteEdit] = useState(true)
    const [postCompleteSettingLoading, setPostCompleteSettingLoading] =
        useState(false)

    const updateMenuPosition = useCallback(() => {
        const anchor = dropdownRef.current
        if (!anchor) return

        const rect = anchor.getBoundingClientRect()
        const spaceBelow = window.innerHeight - rect.bottom
        const openAbove = spaceBelow < MENU_ESTIMATED_HEIGHT

        setMenuStyle({
            top: openAbove ? rect.top - 8 : rect.bottom + 8,
            left: rect.right,
            transform: openAbove
                ? 'translate(-100%, -100%)'
                : 'translateX(-100%)',
        })
    }, [])

    useEffect(() => {
        const handleClickOutside = event => {
            if (
                dropdownRef.current?.contains(event.target) ||
                menuRef.current?.contains(event.target)
            ) {
                return
            }
            setDropdownOpen(false)
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    useEffect(() => {
        if (!dropdownOpen) {
            setMenuStyle(null)
            return undefined
        }

        updateMenuPosition()
        window.addEventListener('scroll', updateMenuPosition, true)
        window.addEventListener('resize', updateMenuPosition)

        return () => {
            window.removeEventListener('scroll', updateMenuPosition, true)
            window.removeEventListener('resize', updateMenuPosition)
        }
    }, [dropdownOpen, updateMenuPosition])

    const actionItem = mapDashboardTaskForActions(item)
    const isCompleted = StatusType.Completed === actionItem.Status
    const inspectionRouteId = getTaskInspectionRouteId(actionItem)
    const isCard = variant === 'card'
    const taskIsReadOnly = isTaskReadOnly(actionItem, user)
    const taskApprovedFlag = getTaskIsApprovedFlag(actionItem)
    const isReportApproved =
        reportApproved === true ||
        approvalInfo?.isApproved === true ||
        taskApprovedFlag === true

    useEffect(() => {
        // Only resolve when Approve can still be shown (completed + not approved)
        if (
            !dropdownOpen ||
            !isCompleted ||
            !showApprove ||
            isReportApproved
        ) {
            return undefined
        }

        const completedReportId = getTaskCompletedReportId(actionItem)
        const auditId = getTaskAuditIdForApproval(actionItem)

        let cancelled = false
        setApprovalStatusLoading(true)
        ReportApprovalService.resolveApprovalForAudit({
            completedReportId,
            auditId,
        })
            .then(resolved => {
                if (cancelled) return
                setApprovalInfo(resolved)
            })
            .catch(() => {
                if (cancelled) return
                setApprovalInfo(null)
            })
            .finally(() => {
                if (!cancelled) setApprovalStatusLoading(false)
            })

        return () => {
            cancelled = true
        }
    }, [
        dropdownOpen,
        isCompleted,
        showApprove,
        isReportApproved,
        actionItem.TaskId,
        actionItem.CompletedReportId,
        actionItem.InspectionId,
        actionItem.AuditId,
        actionItem.IsApproved,
        actionItem.ApprovalStatus,
    ])

    useEffect(() => {
        if (!dropdownOpen || !isCompleted) {
            return undefined
        }

        let cancelled = false

        const resolvePostCompleteEdit = async () => {
            setPostCompleteSettingLoading(true)
            // Hide Reopen until setting is known (avoid flash of wrong option)
            setAllowPostCompleteEdit(false)

            try {
                let templateSettingId = getTaskTemplateSettingId(actionItem)

                if (!templateSettingId) {
                    const auditRouteId = getTaskInspectionRouteId(actionItem)
                    if (auditRouteId) {
                        const audit = await InspectionService.getAudit(
                            auditRouteId,
                        )
                        if (cancelled) return
                        const fromAudit = Number(
                            audit?.OriginalTemplateId ??
                                audit?.originalTemplateId,
                        )
                        if (Number.isFinite(fromAudit) && fromAudit > 0) {
                            templateSettingId = fromAudit
                        }
                    }
                }

                if (!templateSettingId) {
                    if (!cancelled) setAllowPostCompleteEdit(true)
                    return
                }

                try {
                    const setting = await TemplateService.getTemplateSetting(
                        templateSettingId,
                    )
                    if (cancelled) return
                    setAllowPostCompleteEdit(
                        !isPostCompleteEditBlocked(setting),
                    )
                } catch (error) {
                    // 404 / missing config => feature dormant => allow reopen
                    if (!cancelled) setAllowPostCompleteEdit(true)
                }
            } catch (error) {
                if (!cancelled) setAllowPostCompleteEdit(true)
            } finally {
                if (!cancelled) setPostCompleteSettingLoading(false)
            }
        }

        resolvePostCompleteEdit()

        return () => {
            cancelled = true
        }
    }, [
        dropdownOpen,
        isCompleted,
        actionItem.TaskId,
        actionItem.TemplateId,
        actionItem.OriginalTemplateId,
        actionItem.AuditTemplateId,
        actionItem.InspectionId,
    ])

    const handleViewReport = () => {
        onViewReport(actionItem)
        setDropdownOpen(false)
    }

    const handlePrintReportWithTickets = async e => {
        e?.stopPropagation()
        if (printingReport) return

        const auditId = getTaskInspectionRouteId(actionItem)
        if (!auditId) {
            errorToast('Could not print this report. The audit id is missing.')
            setDropdownOpen(false)
            return
        }

        const previewWindow = window.open('', '_blank')
        setPrintingReport(true)
        try {
            const result =
                await InspectionService.getInspectionReportWithTickets(auditId)
            const reportPath =
                result?.ReportPath ||
                result?.reportPath ||
                result?.Data?.ReportPath ||
                result?.data?.ReportPath

            if (!reportPath) {
                previewWindow?.close()
                return
            }

            if (previewWindow) {
                previewWindow.location.href = reportPath
            } else {
                window.open(reportPath, '_blank', 'noopener,noreferrer')
            }
            setDropdownOpen(false)
        } catch (error) {
            previewWindow?.close()
            if (!error?.auditAccessHandled) {
                errorToast(
                    'Could not generate the report with tickets. Please try again.',
                )
            }
        } finally {
            setPrintingReport(false)
        }
    }

    const dismissPreview = () => {
        if (onClosePreview) onClosePreview()
    }

    const handleEdit = e => {
        e?.stopPropagation()
        dismissPreview()
        onEdit(actionItem)
        setDropdownOpen(false)
    }

    const handleDeleteClick = e => {
        e?.stopPropagation()
        dismissPreview()
        setDeleteConfirmOpen(true)
        setDropdownOpen(false)
    }

    const toggleDropdown = e => {
        e?.stopPropagation()
        const next = !dropdownOpen
        if (next) dismissPreview()
        setDropdownOpen(next)
    }

    const handleDeleteConfirm = () => {
        onRemove(actionItem.TaskId)
        setDeleteConfirmOpen(false)
    }

    const handleRejectClick = () => {
        setDropdownOpen(false)
        setRejectOpen(true)
    }

    const handleRejectSubmit = async comment => {
        if (rejecting) return
        setRejecting(true)
        try {
            await onReject(actionItem, comment)
            setRejectOpen(false)
        } catch (error) {
            if (!error?.auditAccessHandled) {
                errorToast('Failed to reject task. Please try again.')
            }
        } finally {
            setRejecting(false)
        }
    }

    const handleReopen = () => {
        onReopen(actionItem)
        setDropdownOpen(false)
    }

    const openInspection = e => {
        e?.stopPropagation()
        e?.preventDefault()
        dismissPreview()
        if (!inspectionRouteId) {
            errorToast(
                'Could not open this inspection. The audit id is missing.',
            )
            return
        }
        navigate(`/app/templates/inspection/${inspectionRouteId}`)
    }

    const handleCreateActionPlan = e => {
        e?.stopPropagation()
        dismissPreview()
        setDropdownOpen(false)
        if (!inspectionRouteId) {
            errorToast(
                'Could not open this inspection. The audit id is missing.',
            )
            return
        }
        navigate(`/app/templates/inspection/${inspectionRouteId}`, {
            state: { isActionPlan: true },
        })
    }

    const handleApproveClick = async e => {
        e?.stopPropagation()
        dismissPreview()
        setDropdownOpen(false)
        if (approving) return

        try {
            setApproving(true)
            const resolved =
                approvalInfo?.completedReportId != null
                    ? approvalInfo
                    : await ReportApprovalService.resolveApprovalForAudit({
                          completedReportId:
                              getTaskCompletedReportId(actionItem),
                          auditId: getTaskAuditIdForApproval(actionItem),
                      })

            if (!resolved?.completedReportId) {
                errorToast(
                    'No completed report found for approval on this task.',
                )
                return
            }

            setApprovalInfo(resolved)
            navigate(`/app/report-approvals/${resolved.completedReportId}`)
        } catch {
            errorToast('Failed to open report approval. Please try again.')
        } finally {
            setApproving(false)
        }
    }

    const companyId = getUserCompanyId(user)
    const showCreateActionPlan =
        isCompleted &&
        user?.CanCreateActionPlan === true &&
        companyId !== WK_COMPANY_ID
    const showReject =
        isCompleted && showApprove && companyId !== WK_COMPANY_ID

    const isDown =
        Number(actionItem.Status) === StatusType.Down ||
        String(actionItem.StatusName || '').toLowerCase() === 'down'

    if (isDown) {
        return (
            <span style={{ color: '#9ca3af', fontSize: 13, fontWeight: 500 }}>
                N/A
            </span>
        )
    }

    let primaryAction
    if (isCompleted) {
        primaryAction = isCard ? (
            <CardPrimaryButton type="button" onClick={handleViewReport}>
                View Report
            </CardPrimaryButton>
        ) : (
            <AppButton onClick={handleViewReport}>View Report</AppButton>
        )
    } else {
        const openLabel = taskIsReadOnly ? 'View Inspection' : 'Resume Inspection'
        primaryAction = isCard ? (
            <CardPrimaryButton type="button" onClick={openInspection}>
                {openLabel}
            </CardPrimaryButton>
        ) : (
            <AppButton onClick={openInspection}>{openLabel}</AppButton>
        )
    }

    let createActionPlanButton = null
    if (showCreateActionPlan && !taskIsReadOnly) {
        createActionPlanButton = isCard ? (
            <CardActionPlanButton
                type="button"
                onClick={handleCreateActionPlan}
            >
                Create Action Plan
            </CardActionPlanButton>
        ) : (
            <AppPrimaryButton
                type="button"
                onClick={handleCreateActionPlan}
            >
                Create Action Plan
            </AppPrimaryButton>
        )
    }

    const menuTrigger = isCard ? (
        <CardActionMenu type="button" onClick={toggleDropdown}>
            …
        </CardActionMenu>
    ) : (
        <Button
            icon
            basic
            onClick={toggleDropdown}
            style={{ padding: '8px', minWidth: 'auto' }}
        >
            <DotsThreeVertical size={20} />
        </Button>
    )

    let approveMenuLabel = 'Approve'
    if (approving || approvalStatusLoading) {
        approveMenuLabel = 'Opening…'
    }

    const showPrintReportWithTicket = isCompleted
    const emailHistoryAuditId = isCompleted
        ? getTaskInspectionRouteId(actionItem) ||
          getTaskAuditIdForApproval(actionItem) ||
          ''
        : ''

    const handleEmailHistory = () => {
        setDropdownOpen(false)
        setEmailHistoryOpen(true)
    }

    const dropdownMenuContent = (
        <>
            {showPrintReportWithTicket && (
                <MenuItem
                    onClick={handlePrintReportWithTickets}
                    disabled={printingReport}
                >
                    <Printer size={16} />
                    <span>
                        {printingReport
                            ? 'Printing…'
                            : 'Print report with ticket'}
                    </span>
                </MenuItem>
            )}
            {!!emailHistoryAuditId && (
                <MenuItem onClick={handleEmailHistory}>
                    <ClockCounterClockwise size={16} />
                    <span>Email history</span>
                </MenuItem>
            )}
            {SHOW_TASK_EDIT_MENU_OPTION && !taskIsReadOnly && (
                <MenuItem onClick={handleEdit}>
                    <PencilSimple size={16} />
                    <span>Edit</span>
                </MenuItem>
            )}
            {isCompleted &&
                !taskIsReadOnly &&
                allowPostCompleteEdit &&
                !postCompleteSettingLoading && (
                <MenuItem onClick={handleReopen}>
                    <Repeat size={16} />
                    <span>Reopen</span>
                </MenuItem>
            )}
            {showReject && (
                <MenuItem onClick={handleRejectClick} danger>
                    <XCircle size={16} />
                    <span>Reject</span>
                </MenuItem>
            )}
            {isCompleted && showApprove && !isReportApproved && (
                <MenuItem
                    onClick={handleApproveClick}
                    disabled={approving || approvalStatusLoading}
                >
                    <CheckCircle size={16} />
                    <span>{approveMenuLabel}</span>
                </MenuItem>
            )}
            {!taskIsReadOnly && (
                <MenuItem onClick={handleDeleteClick} danger>
                    <Trash size={16} />
                    <span>Delete</span>
                </MenuItem>
            )}
        </>
    )

    const hasDropdownActions =
        showPrintReportWithTicket ||
        (SHOW_TASK_EDIT_MENU_OPTION && !taskIsReadOnly) ||
        (isCompleted &&
            !taskIsReadOnly &&
            allowPostCompleteEdit &&
            !postCompleteSettingLoading) ||
        showReject ||
        (isCompleted && showApprove && !isReportApproved) ||
        !taskIsReadOnly

    const renderPortaledMenu = () => {
        if (!dropdownOpen || !menuStyle) return null

        return createPortal(
            <DropdownMenuPortal ref={menuRef} style={menuStyle}>
                {dropdownMenuContent}
            </DropdownMenuPortal>,
            document.body,
        )
    }

    return (
        <>
            {isCard ? (
                <CardActionsRow>
                    {primaryAction}
                    {createActionPlanButton}
                    {hasDropdownActions && (
                        <ActionDropdownContainer ref={dropdownRef}>
                            {menuTrigger}
                        </ActionDropdownContainer>
                    )}
                </CardActionsRow>
            ) : (
            <FlexBox className="gap-2 align-items-center">
                {primaryAction}
                {createActionPlanButton}
                {hasDropdownActions && (
                    <ActionDropdownContainer ref={dropdownRef}>
                        {menuTrigger}
                    </ActionDropdownContainer>
                )}
            </FlexBox>
            )}
            {hasDropdownActions && renderPortaledMenu()}
            {emailHistoryOpen && !!emailHistoryAuditId && (
                <EmailHistoryPanel
                    open
                    showSendEmail
                    auditId={emailHistoryAuditId}
                    onClose={() => setEmailHistoryOpen(false)}
                />
            )}
            {showReject && (
                <RejectModal
                    open={rejectOpen}
                    onClose={() => setRejectOpen(false)}
                    onSubmit={handleRejectSubmit}
                    loading={rejecting}
                />
            )}
            <Modal open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)} size="tiny" className="model">
                <Modal.Header>
                    <FlexRowBetween>
                        <span>Delete Task</span>
                        <X className="pointer" size={32} onClick={() => setDeleteConfirmOpen(false)} />
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content>
                    <p>Are you sure you want to delete this task?</p>
                </Modal.Content>
                <Modal.Actions>
                    <AppButton onClick={() => setDeleteConfirmOpen(false)}>
                        Cancel
                    </AppButton>
                    <AppPrimaryButton onClick={handleDeleteConfirm} style={{ backgroundColor: '#dc3545' }}>
                        Delete
                    </AppPrimaryButton>
                </Modal.Actions>
            </Modal>
        </>
    )
}

const TaskCard = ({
    item,
    onRemove,
    onEdit,
    onViewReport,
    onReopen,
    onReject,
    selectedIds = [],
    onSelectionChange,
}) => {
    const companyId =
        AuthService.getUser()?.Companies?.[0]?.CompanyId ||
        AuthService.getUser()?.CompanyId
    return (
        <Card fluid>
            <CardContent>
                <FlexRowBetween>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div>
                            <Checkbox
                                checked={selectedIds?.includes(item.TaskId)}
                                onChange={(e, { checked }) => {
                                    if (onSelectionChange) {
                                        if (checked) {
                                            onSelectionChange([...selectedIds, item.TaskId])
                                        } else {
                                            onSelectionChange(selectedIds.filter(id => id !== item.TaskId))
                                        }
                                    }
                                }}
                            />
                        </div>
                        <h4 title={item.CustomerName} style={{ margin: 0 }}>
                            {CommonUtility.truncateString(item.CustomerName, 20)}
                        </h4>
                        {(item.StatusName ||
                            Number(item.Status) === StatusType.Down) && (
                            <span
                                style={{
                                    backgroundColor:
                                        Number(item.Status) === StatusType.Down
                                            ? '#d32f2f'
                                            : 'teal',
                                    color: 'white',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    display: 'inline-block',
                                    marginLeft: '8px',
                                    fontWeight: 500,
                                }}
                            >
                                {Number(item.Status) === StatusType.Down
                                    ? 'Down'
                                    : item.StatusName}
                            </span>
                        )}
                    </div>
                </FlexRowBetween>
                {companyId !== 34930 && (
                    <h5 className="mt-0 align-items-center d-flex">
                        <Clock className="me-1" />
                        {DateUtility.dateToLocalISO(
                            new Date(item.InspectionDate),
                            DateFormat.mmDD,
                        )}{' '}
                        -
                        {DateUtility.dateToLocalISO(
                            new Date(item.TaskDue),
                            DateFormat.mmDD,
                        )}
                    </h5>
                )}
                <FlexRowWrap className="justify-content-end ">
                    <TaskActionBoxes
                        item={item}
                        onViewReport={onViewReport}
                        onEdit={onEdit}
                        onRemove={onRemove}
                        onReject={onReject}
                        onReopen={onReopen}
                    />
                </FlexRowWrap>
            </CardContent>
        </Card>
    )
}

export default TaskCard

export const TaskCards = ({
    item,
    onRemove,
    onEdit,
    // onViewReport,
    // onReopen,
    // onReject,
    selectedIds = [],
    onSelectionChange,
}) => {
    // const handleRejectWithComment = comment => {
    //     onReject(item, comment)
    // }

    return (
        <Card fluid>
            <CardContent>
                <FlexRowBetween>
                    <div>
                        <Checkbox
                            checked={selectedIds?.includes(item.Id)}
                            onChange={(e, { checked }) => {
                                if (onSelectionChange) {
                                    if (checked) {
                                        onSelectionChange([...selectedIds, item.Id])
                                    } else {
                                        onSelectionChange(selectedIds.filter(id => id !== item.Id))
                                    }
                                }
                            }}
                        />
                    </div>
                    <h4 title={item.CustomerName}>
                        {CommonUtility.truncateString(item.Title, 20)}
                    </h4>
                    <span>
                        <Label>{item.FrequencyLabel}</Label>
                    </span>
                </FlexRowBetween>
                <h5 className="mt-0 align-items-center d-flex">
                    <span>
                        <Label>
                            {item.TemplateName}-{item.CustomerName}
                        </Label>
                    </span>
                    {/* {DateUtility.dateToLocalISO(
                        new Date(item.InspectionDate),
                        DateFormat.mmDD,
                    )}{' '}
                    -
                    {DateUtility.dateToLocalISO(
                        new Date(item.TaskDue),
                        DateFormat.mmDD,
                    )} */}
                </h5>
                <h5 className="mt-1 align-items-center d-flex">
                    <Clock className="me-1" />
                    <span>With in {item.DueDays} DueDays</span>
                </h5>
                <FlexRowWrap className="justify-content-end ">
                    {/* {StatusType.Completed === item.Status ? (
                        <>
                            <AppSecondaryButton
                                onClick={() => onViewReport(item)}
                            >
                                View Report
                            </AppSecondaryButton>
                            <Popup
                                content="Reopen"
                                trigger={
                                    <AppPrimaryButton
                                        onClick={() => onReopen(item)}
                                    >
                                        <Repeat size={15} />
                                    </AppPrimaryButton>
                                }
                            />
                            <RejectModal
                                onReject={handleRejectWithComment}
                                trigger={
                                    <AppSecondaryButton>
                                        <XCircle size={15} />
                                    </AppSecondaryButton>
                                }
                                item={item}
                            />
                            <AppPrimaryButton
                                onClick={() => onEdit(item)}
                                type="button"
                            >
                                <PencilSimple size={15} />
                            </AppPrimaryButton>
                            <AppRemoveButtonPopup
                                onConfirm={() => onRemove(item.Id)}
                                icon={<Trash size={15} />}
                            />
                        </>
                    ) : ( */}
                    <>
                        <Link
                            to={`/app/templates/inspection/${getTaskInspectionRouteId(mapDashboardTaskForActions(item))}`}
                        >
                            {/* <AppSecondaryButton title="Resume Inspection">
                                    Resume
                                </AppSecondaryButton> */}
                        </Link>
                        <AppEditButton onClick={() => onEdit(item)} />
                        <AppRemoveButtonPopup
                            onConfirm={() => onRemove(item.Id)}
                        />
                    </>
                    {/* )} */}
                </FlexRowWrap>
            </CardContent>
        </Card>
    )
}

export const InspectionTaskList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    onRemove,
    onEdit,
    onResume,
    onViewReport,
    onReopen,
    onReject,
    selectedIds = [],
    onSelectionChange,
}) => {
    const handleReject = (item, comment) => {
        console.log('Rejecting item:', item, 'with comment:', comment)
        onReject(item, comment)
    }
    const isMobile = useTabletAndBelowMediaQuery()
    const companyId =
        AuthService.getUser()?.Companies?.[0]?.CompanyId ||
        AuthService.getUser()?.CompanyId
    const hideDueDate = companyId === 34930

    const columns = useMemo(() => {
        const currentPageIds = (data || []).map(item => item.TaskId)
        const baseColumns = [
            {
                title: (
                    <div className="d-flex justify-content-center">
                        <Checkbox
                            checked={
                                currentPageIds.length > 0 &&
                                currentPageIds.every(id =>
                                    selectedIds.includes(id),
                                )
                            }
                            indeterminate={
                                currentPageIds.some(id =>
                                    selectedIds.includes(id),
                                ) &&
                                !currentPageIds.every(id =>
                                    selectedIds.includes(id),
                                )
                            }
                            onChange={(e, { checked }) => {
                                if (checked) {
                                    onSelectionChange(
                                        Array.from(
                                            new Set([
                                                ...selectedIds,
                                                ...currentPageIds,
                                            ]),
                                        ),
                                    )
                                } else {
                                    onSelectionChange(
                                        selectedIds.filter(
                                            id => !currentPageIds.includes(id),
                                        ),
                                    )
                                }
                            }}
                        />
                    </div>
                ),
                render: item => (
                    <div className="d-flex justify-content-center">
                        <Checkbox
                            checked={selectedIds.includes(item.TaskId)}
                            onChange={(e, { checked }) => {
                                if (checked) {
                                    onSelectionChange([...selectedIds, item.TaskId])
                                } else {
                                    onSelectionChange(selectedIds.filter(id => id !== item.TaskId))
                                }
                            }}
                        />
                    </div>
                ),
                width: '50px',
            },
            {
                title: companyId === 34930 ? 'Auditor Name' : 'User Name',
                render: item => (
                    <span>{item.CreatedByName}</span>
                ),
            },
            {
                title: 'Template',
                key: 'CustomerName',
            },
            {
                title: 'Status',
                key: 'StatusName',
            },
        ]

        if (!hideDueDate) {
            baseColumns.push({
                title: 'Due Date',
                render: item => (
                    <span>
                        {DateUtility.dateToLocalISO(
                            new Date(item.TaskDue),
                            DateFormat.date,
                        )}
                    </span>
                ),
            })
        }

        baseColumns.push({
            title: 'Actions',
            key: 'Actions',
            render: item => (
                <FlexBox className="justify-content-center">
                    <TaskActionBoxes
                        key={item.TaskId}
                        item={item}
                        onViewReport={onViewReport}
                        onEdit={onEdit}
                        onRemove={onRemove}
                        onReject={handleReject}
                        onReopen={onReopen}
                    />
                </FlexBox>
            ),
        })

        return baseColumns
    }, [
        data,
        totalCount,
        filter,
        isMobile,
        hideDueDate,
        onEdit,
        onRemove,
        onReopen,
        selectedIds,
        onSelectionChange,
    ])
    return (
        <>
            <AppTable
                data={data}
                columns={columns}
                pageChanged={pageChanged}
                filter={filter}
                totalCount={totalCount}
                mobileCard={
                    <TaskCard
                        onEdit={onEdit}
                        onRemove={onRemove}
                        onResume={onResume}
                        onViewReport={onViewReport}
                        onReopen={onReopen}
                        onReject={handleReject}
                        selectedIds={selectedIds}
                        onSelectionChange={onSelectionChange}
                    />
                }
            />
        </>
    )
}
export const ScheduleTaskListScreen = ({
    scheduledTasks,
    onEdit,
    onRemove,
    pageChanged,
    totalCount,
    filter,
    selectedIds = [],
    onSelectionChange,
}) => {
    // const isMobile = useTabletAndBelowMediaQuery();

    const columns = useMemo(
        () => [
            {
                title: (
                    <div className="d-flex justify-content-center">
                        <Checkbox
                            checked={scheduledTasks.length > 0 && scheduledTasks.every(item => selectedIds.includes(item.Id))}
                            indeterminate={scheduledTasks.some(item => selectedIds.includes(item.Id)) && !scheduledTasks.every(item => selectedIds.includes(item.Id))}
                            onChange={(e, { checked }) => {
                                const currentPageIds = scheduledTasks.map(item => item.Id)
                                if (checked) {
                                    onSelectionChange(Array.from(new Set([...selectedIds, ...currentPageIds])))
                                } else {
                                    onSelectionChange(selectedIds.filter(id => !currentPageIds.includes(id)))
                                }
                            }}
                        />
                    </div>
                ),
                render: item => (
                    <div className="d-flex justify-content-center">
                        <Checkbox
                            checked={selectedIds.includes(item.Id)}
                            onChange={(e, { checked }) => {
                                if (checked) {
                                    onSelectionChange([...selectedIds, item.Id])
                                } else {
                                    onSelectionChange(selectedIds.filter(id => id !== item.Id))
                                }
                            }}
                        />
                    </div>
                ),
                width: '50px',
            },
            {
                title: 'Title',
                key: 'Title',
            },
            // {
            //     title: 'Customer',
            //     key: 'TemplateName',
            // },
            {
                title: 'Customer',
                key: 'Customer',
                render: item => (
                    <div>
                        <span>{item.TemplateName}</span>-
                        <span>{item.CustomerName}</span>
                    </div>
                ),
            },
            {
                title: 'Team Member',
                key: 'TeamMemberName',
            },
            {
                title: 'Frequency',
                key: 'FrequencyLabel',
            },
            {
                title: 'Due Days',
                key: 'DueDays',
            },
            {
                title: 'Actions',
                key: 'Actions',
                render: item => (
                    <FlexBox className="justify-content-center">
                        <AppPrimaryButton
                            onClick={() => onEdit(item)}
                            type="button"
                        >
                            <PencilSimple size={15} />
                        </AppPrimaryButton>
                        <AppRemoveButtonPopup
                            onConfirm={() => {
                                console.log('Item passed to onRemove:', item)
                                onRemove(item.Id)
                            }}
                        />
                    </FlexBox>
                ),
            },
        ],
        [scheduledTasks, totalCount, pageChanged, selectedIds, onSelectionChange],
    )

    return (
        <div className="my-3">
            {/* <h2>Schedule Task List</h2> */}
            {scheduledTasks.length > 0 ? (
                <AppTable
                    data={scheduledTasks}
                    columns={columns}
                    totalCount={totalCount}
                    pageChanged={pageChanged}
                    filter={filter}
                    mobileCard={
                        <TaskCards
                            onEdit={onEdit}
                            onRemove={onRemove}
                            totalCount={totalCount}
                            pageChanged={pageChanged}
                            filter={filter}
                            selectedIds={selectedIds}
                            onSelectionChange={onSelectionChange}
                        />
                    }
                />
            ) : (
                <p>No scheduled tasks found.</p>
            )}
        </div>
    )
}
